import { SiteFeatureId } from 'app/constants/enums/SiteFeature/data';
import { MeetingsConfig } from './MeetingsConfig';
import { UsersConfig } from './UsersConfig';

type SiteConfigurationForId<Id extends SiteFeatureId> = Id extends 'meetings' ? MeetingsConfig :
  Id extends 'users' ? UsersConfig : null;

/**
 * There needs to be a distinction between `null` representing no configuration for
 * a type and None representing that the value is not supported at all (ie not enabled).
 *
 * This could be achieved with `null` and `undefined` but it is much clearer to use the Option type
 * for this distinction.
 */
export type ConfigurationForSiteFeatures = {
  [Id in SiteFeatureId]: {
    enabled: false;
    configuration: null;
  } | {
    enabled: true;
    configuration: SiteConfigurationForId<Id> | null;
  }
};

const DISABLED_CONFIGURATION = { enabled: false, configuration: null };
export const NO_FEATURES_ENABLED: ConfigurationForSiteFeatures = {
  meetings: DISABLED_CONFIGURATION,
  iknowIntegration: DISABLED_CONFIGURATION,
  dailyNews: DISABLED_CONFIGURATION,
  users: DISABLED_CONFIGURATION,
  wordsPage: DISABLED_CONFIGURATION,
  materials: DISABLED_CONFIGURATION,
};
